import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DataTable } from '../patterns';
import type { DataTableColumn } from '../patterns';
import type { NutritionSummary } from '../../services/nutritionService';

type AuditOrchard = NonNullable<NutritionSummary['audit']>['orchards'][number];

const fmt = (v: number | null | undefined): string => (v == null ? '—' : String(v));

export const NutritionNpkBand: React.FC<{
  audit?: NutritionSummary['audit'];
}> = ({ audit }) => {
  const { t } = useTranslation();

  if (!audit || audit.orchards.length === 0) return null;

  const columns: DataTableColumn<AuditOrchard>[] = [
    { key: 'orchardNo', label: t('nutrition.dashboard.npk.col.orchard') },
    { key: 'n', label: t('nutrition.dashboard.npk.col.n'), align: 'right', render: (r) => fmt(r.n) },
    { key: 'p', label: t('nutrition.dashboard.npk.col.p'), align: 'right', render: (r) => fmt(r.p) },
    { key: 'k', label: t('nutrition.dashboard.npk.col.k'), align: 'right', render: (r) => fmt(r.k) },
  ];

  return (
    <section className="ntr-dash-band">
      <header className="ntr-dash-card__head">
        <h3>{t('nutrition.dashboard.npk.title')}</h3>
        <Link to="/nutrition/audit">{t('nutrition.dashboard.npk.viewAll')}</Link>
      </header>
      <DataTable<AuditOrchard>
        columns={columns}
        rows={audit.orchards}
        rowKey={(r) => r.orchardId}
        mobileCardRow={(r) => (
          <div>
            <strong>{r.orchardNo}</strong>
            <div style={{ fontSize: 11, color: 'var(--shell-text-muted)' }}>
              N {fmt(r.n)} · P {fmt(r.p)} · K {fmt(r.k)}
            </div>
          </div>
        )}
      />
    </section>
  );
};

export default NutritionNpkBand;
